module.exports = require("nba");


//////////////////
// WEBPACK FOOTER
// external "nba"
// module id = 31
// module chunks = 0